import React, { Component } from 'react'
import _ from 'lodash'
import { apiProcess } from '../api/api.js'
import { validateURLDates } from '../utils'
import MetaTags from '../elements/meta/metaTags.js'
import ProductSchema from '../elements/meta/productSchema.js'
import QueryString from 'query-string'
import './BikeListing.css'
import { trackBikePageViewed } from './../elements/klaviyoTracking/bikeProfile'
import { trackBikeProfilePageView } from '../elements/tracking/bikeProfileTracking.js'
import { Container, Columns } from '../../components/elements'
import DateWarningTicker from '../../components/elements/dateWarningTicker'

/*Moto Sections*/
import Description from './sections/description'
import OwnerInfo from './sections/ownerInformation/OwnerInfo'
import BikeModelDescription from './sections/description/BikeModelDescription'
import Stats from './sections/stats'
import LoaderPage from '../../components/elements/skeletons/TempSkeleton'
import Parking from './sections/parkingInformation/parking'
// import AboutLocation from './sections/aboutLocation/AboutLocation'
import LocationMap from './sections/locationMap/locationMap'
import BikeProfileMotorcycleEvents from './sections/bikeProfieEvents/BikeProfileMotorcycleEvents'
// import BikeGear from './sections/gear/index.js'
import BikePhotoSlider from './heroImages/BikeListingPhotosSlider.js'
import BikeBreadCrumbs from './breadcrumbs/bikeBreadCrumbs.js'
import BikeListingGridView from './heroImages/BikeListingGridView'
import BikeListingReviewWrap from './reviews/bikeListingReviewWrap.js'
import ProfileHeader from './sections/header'
import { convertCents } from './../../components/utils'
import MultiDayDiscounts from './../bikes/sections/multiDayDiscounts/index'

/*Tools and Actions*/
import ProfileImageGridModal from './heroImages/ProfileImageGridModal'
// import SellingCallOut from './sections/sellingCallOut.js'
import MotorcycleBookingPanelWrapper from './bookingCalendarPanel/paymentModulePropWrapper'
import moment from 'moment-timezone'
import { TryMeModal } from 'components/elements'
import BikeWasDeleted from './BikeWasDeleted.js'
import { auth } from 'components/auth/auth.js'
// import GearDescription from './sections/description/GearDescription.js'
// import RideRecommendition from './sections/recommends/RideRecommendition.js'
var worryFreeLogo = require('../theme/assets/images/100_percent.webp')
var cancelLogo = require('../theme/assets/images/cancel.webp')
var calendarLogo = require('../theme/assets/images/calendar.webp')

class BikeListing extends Component {
  contentCheckInterval = null
  constructor(props) {
    super(props)

    let startDate = null
    let endDate = null

    const parsedQueries = QueryString.parse(this.props.location.search)

    if (parsedQueries.startDate && parsedQueries.endDate) {
      if (validateURLDates(parsedQueries.startDate, parsedQueries.endDate)) {
        startDate = parsedQueries.startDate
        endDate = parsedQueries.endDate
      }
    }

    this.state = {
      loading: false,
      bikeID: null,
      hasBikeData: false,
      bikeData: null,
      hasErrors: false,
      hasURLBannerError: false,
      urlBannerErrorMessages: '',
      startDate: startDate, //null, string, or moment Obj
      endDate: endDate, //null string, or moment Obj,
      startTime: null,
      endTime: null,
      pickup_timings: null,
      dropoff_timings: null,
      chatSession: null,
      showTryMeModal: false,
      showGridModal: false,
      reviews: {
        data: [],
        hasMore: false,
        page: 1,
        pageCount: 5,
        isLoading: false,
      },
      inactiveBikeDetails: null
    }
  }

  componentWillMount() {
    if (!this.props.isMobile) {
      document.body.style.overflowX = 'unset'
    }
  }

  componentWillUnmount() {
    if (this.contentCheckInterval) {
        clearInterval(this.contentCheckInterval)
        this.contentCheckInterval = null
    }

    if (!this.props.isMobile) {
      document.body.style.overflowX = 'hidden'
    }
  }

  componentDidMount() {
    this.setState({
      loading: true,
    })

    const isLoggedIn = auth.isAuthenticated()
    const isTripTaken = Number(auth.userRideTakenCount()) > 0

    if (!isLoggedIn || !isTripTaken) {
      document.body.classList.add(`klaviyo-${this.props.isMobile ? 'mobile' : 'desktop'}-banner-added`)
    }

    window.scrollTo(0, 0)

    let baseURL = 'motorcycles/' + this.props.match.params.bikeID

    let parsedQueries = QueryString.parse(this.props.location.search)

    let url = parsedQueries.dealer_access_token
      ? `${baseURL}?dealer_access_token=${parsedQueries.dealer_access_token}`
      : baseURL

    apiProcess(url, false, 'bike-profile', 'Bike Listing Show Page ' + baseURL)
      .then(
        function (responseData) {

          if (responseData?.status == false) {
            this.setState({
              inactiveBikeDetails: responseData || {}
            })
            throw new Error(responseData?.message || 'Motorcycle not found')
          }

          setTimeout(() => {
            const parsedQueries = QueryString.parse(this.props.location.search)
            this.setState({
              bikeData: responseData,
              defaultBikeData: JSON.parse(JSON.stringify(responseData || {})), //there an immutable problem happening. who knows. this fixes resetting to default price on dates clear
              loading: false,
              hasBikeData: responseData ? true : false,
              bikeID: this.props.match.params.bikeID,
              chatSession: responseData?.chat_session,
              showTryMeModal: parsedQueries.try_me == 1,
              reviews: {
                ...this.state.reviews,
                data: responseData?.bike_guest_reviews,
                hasMore:
                  responseData?.bike_guest_reviews?.length ===
                  this.state.reviews.pageCount,
              },
            })

            if (parsedQueries.errorMessage) {
              this.setState({
                hasURLBannerError: true,
                urlBannerErrorMessage: parsedQueries.errorMessage,
              })
            }
            trackBikePageViewed(
              this.props.match.params.bikeID,
              responseData.bike_year,
              responseData.bike_make,
              responseData.bike_model,
              responseData.bike_location.location_city,
              responseData.bike_location.location_region,
              window.location.href,
              responseData.bike_images[0].bike_image_url,
              responseData.base_bike_daily_price_cents / 100,
              responseData.bike_owner_name
            )
            trackBikeProfilePageView(responseData)
          }, 1000)
        }.bind(this)
      )
      .catch(
        function (errorResponse) {
          this.setState({
            hasErrors: true,
            loading: false,
            errorInfo: errorResponse,
          })
        }.bind(this)
      )
  }

  // This function helps make the container not sticky while editing delivery
  toggleFixedClass = (removeOrNot) => {
    if (!this.props.isMobile) {
      if (removeOrNot) {
        document
          .querySelector('#itemThatIsFixed')
          .classList.remove('fixedElement')
      } else {
        document.querySelector('#itemThatIsFixed').classList.add('fixedElement')
      }
    }
  }

  onClearDates = () => {
    this.setState((state) => {
      state.bikeData.bike_daily_price_cents =
        state.defaultBikeData.bike_daily_price_cents
      state.bikeData.bike_daily_price_currency =
        state.defaultBikeData.bike_daily_price_currency
      state.bikeData.multiday_discount_applied =
        state.defaultBikeData.multiday_discount_applied
      state.startDate = null
      state.endDate = null
      return state
    })
  }

  onPricingSuccess = (pricingInfo) => {
    this.setState((state) => {
      state.bikeData.bike_daily_price_cents =
        pricingInfo.totals.bike_rental_daily.bike_rental_daily_cents
      state.bikeData.bike_daily_price_currency =
        pricingInfo.totals.bike_rental_daily.bike_rental_daily_currency
      state.bikeData.multiday_discount_applied =
        pricingInfo.request_details.multi_day_discount_applied
      state.bikeData.startTime = pricingInfo.request_details.start_at
      state.bikeData.endTime = pricingInfo.request_details.end_at
      state.bikeData.pickup_timings = pricingInfo.request_details.pickup_timings
      state.bikeData.dropoff_timings =
        pricingInfo.request_details.dropoff_timings
      return state
    })
  }

  chatSessionCreateCallback = (chatSession) => {
    this.setState({ chatSession })
  }

  loadMoreReviews = () => {
    const {
      reviews: { data, page, pageCount },
    } = this.state

    const url = `motorcycles/${this.props.match.params.bikeID
      }/reviews?page=${page + 1}&page_count=${pageCount}`
    this.setState({
      reviews: {
        ...this.state.reviews,
        isLoading: true,
      },
    })
    apiProcess(url, false, 'bike-reviews', 'Bike Reviews ' + url)
      .then(
        function (reviews) {
          this.setState({
            reviews: {
              data: [...data, ...reviews],
              page: page + 1,
              hasMore: reviews.length === pageCount,
              isLoading: false,
              pageCount,
            },
          })
        }.bind(this)
      )
      .catch(
        function (errorResponse) {
          this.setState({
            hasErrors: true,
            loading: false,
            errorInfo: errorResponse,
          })
        }.bind(this)
      )
  }

  render() {
    let responseTime = null
    let extractedProfileImage = []
    const {
      bikeData,
      loading,
      hasBikeData,
      hasErrors,
      startDate,
      endDate,
      showTryMeModal,
      reviews,
      inactiveBikeDetails
    } = this.state

    if (bikeData) {
      bikeData.bike_images.map((image, index) => {
        if (index < 5) {
          extractedProfileImage.push(image)
        }
      })
    }

    if (hasBikeData) {
      if (bikeData.owner_response_time) {
        responseTime = moment
          .duration(bikeData.owner_response_time, 'milliseconds')
          .humanize()
      }
    }

    const showResponseTime = () => {
      if (is_partner) {
        if (bikeData.partner_allow_messaging) {
          return true
        }
        return false
      }
      return true
    }

    const toggleImageModal = () => {
      this.setState({ showGridModal: !this.state.showGridModal })
    }

    const showDateWarning =
      !startDate && !endDate && bikeData && bikeData.has_multiday_discount

    const {
      isMobile,
      auth: {
        state: { isAuth, userID },
        openLogin,
        handlePhoneVerified,
      },
    } = this.props

    const is_partner = _.get(bikeData, 'is_partner')

    return (
      <>
        {isMobile && hasBikeData && bikeData && (
          <div className="floating-booking-footer">
            <MotorcycleBookingPanelWrapper
              bikeData={bikeData}
              isPartner={bikeData.is_partner}
              bikeID={this.props.match.params.bikeID}
              startDate={this.state.startDate}
              endDate={this.state.endDate}
              paneView={'mobile'}
              toggleFixedClass={this.toggleFixedClass}
              onClearDates={this.onClearDates}
              onDatesChange={(startDate, endDate) =>
                this.setState({ startDate, endDate })
              }
              onPricingSuccess={(pricingInfo) =>
                this.onPricingSuccess(pricingInfo)
              }
            />
          </div>
        )}

        {showDateWarning && isMobile && (
          <DateWarningTicker position="absolute" />
        )}

        {hasErrors && <BikeWasDeleted inactiveBikeDetails={inactiveBikeDetails}/>}

        {loading && !hasBikeData && (
          <LoaderPage text="Warming Up..." loaderClass="top-75" />
        )}

        {!loading && hasBikeData && (
          <React.Fragment>
            <MetaTags
              title={
                bikeData.bike_year.toString() +
                ' ' +
                bikeData.bike_make +
                ' ' +
                bikeData.bike_model +
                ' Motorcycle Rental in ' +
                bikeData.bike_location.location_city +
                ', ' +
                bikeData.bike_location.location_region_abbr +
                ' ' +
                this.props.match.params.bikeID +
                ' '
              }
              description={
                bikeData.bike_year.toString() +
                ' ' +
                bikeData.bike_make +
                ' ' +
                bikeData.bike_model +
                ' motorcycle rental in ' +
                bikeData.bike_location.location_city +
                ', ' +
                bikeData.bike_location.location_region_abbr +
                '. ' +
                bikeData.bike_description
              }
              facebookDescription={bikeData.bike_description}
              url={bikeData.bike_url}
              type="product"
              image_id={
                bikeData.bike_images.length > 0
                  ? bikeData.bike_images[0].bike_image_cloudinary_public_id
                  : null
              }
            />
            {!isMobile && (
              <BikeListingGridView
                toggleModal={toggleImageModal}
                isMobile={isMobile}
                isReviewModal={false}
                profileImages={extractedProfileImage}
                allImages={bikeData.bike_images}
                bikeData={bikeData}
                isProfileImage={true}
              />
            )}
            {isMobile && (
              <BikePhotoSlider
                isMobile={isMobile}
                profileImages={bikeData.bike_images}
                bikeData={bikeData}
              />
            )}
            <Container className="medium py-0 is-relative">
              <ProductSchema productData={bikeData} />
              {this.state.hasURLBannerError && (
                <div className="banner-error">
                  {this.state.urlBannerErrorMessage}
                </div>
              )}
              <Columns>
                <Columns.Column size={4} offset={'none'}>
                  <div className="bike-profile-actions">
                    <ProfileImageGridModal
                      showGridModal={this.state.showGridModal}
                      toggleModal={() => {
                        this.setState({
                          showGridModal: !this.state.showGridModal,
                        })
                      }}
                      isMobile={isMobile}
                      profileImages={bikeData.bike_images}
                      bikeData={bikeData}
                      images_length={bikeData.bike_images.length}
                      isProfileImage={true}
                      bikePrettyID={this.props.match.params.bikeID}
                    />
                  </div>
                </Columns.Column>
              </Columns>
              <Columns>
                <Columns.Column
                  size={7}
                  className="motorcycle-profile-breadcrumbs-wrapper"
                >
                  {!isMobile && (
                    <BikeBreadCrumbs
                      city={bikeData.bike_location.location_city.toLowerCase()}
                      region={bikeData.bike_location.location_region_abbr.toLowerCase()}
                      make={bikeData.bike_make.toLowerCase()}
                      category={bikeData.bike_category.toLowerCase()}
                    />
                  )}

                  <div className="motorcycle-profile-section-header">
                    <Columns>
                      <Columns.Column size={12}>
                        <ProfileHeader
                          bikeData={bikeData}
                          isMobile={isMobile}
                        />
                      </Columns.Column>
                    </Columns>
                  </div>
                  <div className="description-header">Bike Description</div>
                  <div>
                    <Stats bikeData={bikeData} />
                  </div>
                  {bikeData.bike_description !== null && (
                    <div className="motorcycle-profile-section">
                      <Description
                        bike_description={bikeData.bike_description}
                      />
                    </div>
                  )}
                  <div className="motorcycle-profile-section-owner-info">
                    <OwnerInfo
                      handlePhoneVerified={handlePhoneVerified}
                      isAuth={isAuth}
                      userID={userID}
                      openLogin={openLogin}
                      bikeData={bikeData}
                      isMobile={isMobile}
                      responseTime={responseTime}
                      showResponseTime={showResponseTime}
                    />
                  </div>
                  <div className="motorcycle-profile-section-table">
                    <BikeModelDescription bikeData={bikeData} />
                  </div>
                  {bikeData.has_multiday_discount &&
                    bikeData.bike_multi_day_pricing &&
                    convertCents(bikeData.base_bike_daily_price_cents) > 64 && (
                      <div className="motorcycle-profile-section-table">
                        <MultiDayDiscounts
                          multiDayDiscounts={bikeData.bike_multi_day_pricing}
                        />
                      </div>
                    )}
                  {/* <div className="motorcycle-profile-section-table">
                    <GearDescription />
                  </div> */}
                  <div className="motorcycle-profile-section parking">
                    <Parking bikeData={bikeData} />
                  </div>
                  {/* {Object.keys(bikeData.performance).length > 0 && (
                      <div className="motorcycle-profile-section">
                        <Performance bikeData={bikeData} />
                      </div>
                    )}
                eve    {bikeData.gear && bikeData.gear.helmets.length > 0 && (
                      <div className="motorcycle-profile-section">
                        <BikeGear gearInfo={bikeData.gear} />
                      </div>
                    )} */}
                  
                  <div className="motorcycle-profile-section about-location">
                    <LocationMap bikeData={bikeData} isMobile={isMobile} />
                  </div>
                  {/* <div className="motorcycle-profile-section about-location">
                    <AboutLocation bikeData={bikeData} isMobile={isMobile} />
                  </div> */}
                  {bikeData?.nearby_events?.length > 0 && (
                    <div className="motorcycle-profile-section events">
                      <BikeProfileMotorcycleEvents
                        bikeData={bikeData}
                        isMobile={isMobile}
                        isAuth={isAuth}
                      />
                    </div>
                  )}
                  {/* <div
                    id="ride-recommendtion"
                    className="motorcycle-profile-section"
                  >
                    <RideRecommendition
                      bikeData={bikeData}
                      isMobile={isMobile}
                    />
                  </div> */}
                  {/* {this.props.isMobile && bikeData.for_sale && (
                      <SellingCallOut
                        className="mb-6"
                        motorcycleUUID={bikeData.bike_uuid_id}
                        isPartner={bikeData.is_partner}
                        sellPriceCents={bikeData.sale_price_cents}
                        sellPriceCurrency={bikeData.sale_price_currency}
                        sellerAvatarCloudinaryID={
                          bikeData.bike_owner_avatar_cloudinary_public_id
                        }
                        sellerID={bikeData.bike_owner_id}
                        sellerName={bikeData.bike_owner_name}
                        ownerLink={bikeData.owner_link}
                        monthlyPriceCents={bikeData.sale_price_monthly_cents}
                        monthlyPriceCurrency={
                          bikeData.sale_price_monthly_currency
                        }
                      />
                    )} */}
                  <BikeListingReviewWrap
                    bikeData={bikeData}
                    reviews={bikeData.bike_guest_reviews}
                    hasMore={this.state.reviews.hasMore}
                    reviewCount={bikeData.bike_review_count}
                    reviewOverallRating={bikeData.bike_overall_rating}
                    bikeOwnerRating={bikeData.bike_owner_rating}
                    tripsTaken={bikeData.trips_taken}
                    bikeId={this.props.match.params.bikeID}
                    isMobile={this.props.isMobile}
                  />
                </Columns.Column>
                <Columns.Column size={4} offset={1}>
                  {!isMobile && ( //quick fix to cause a re-render. should be doing a componentdidupdate on the inside component
                    <div id="itemThatIsFixed" className="fixedElement">
                      <div className="bike-listing-pay-box-wrap">
                        <MotorcycleBookingPanelWrapper
                          bikeData={bikeData}
                          bikeID={this.props.match.params.bikeID}
                          startDate={this.state.startDate}
                          endDate={this.state.endDate}
                          paneView={'desktop'}
                          toggleFixedClass={this.toggleFixedClass}
                          onClearDates={this.onClearDates}
                          onDatesChange={(startDate, endDate) =>
                            this.setState({ startDate, endDate })
                          }
                          onPricingSuccess={(pricingInfo) =>
                            this.onPricingSuccess(pricingInfo)
                          }
                        />
                      </div>
                      <div className="flexible-cancellation">
                        <div className="flexible-cancellation-icon">
                          <img
                            className="flexibleCancellation-image"
                            src={cancelLogo}
                          ></img>
                        </div>
                        <div className="flexible-cancellation-sub">
                          <b className="has-black-dark-text">
                            <p>Flexible cancellation</p>
                          </b>
                          <p>
                            <a
                              href="https://support.twistedroad.com/article/107-cancelling-a-trip"
                              target="_blank"
                            >
                              <u>Learn more</u>
                            </a>
                          </p>
                        </div>
                      </div>
                      <div className="worry-free-guarantee">
                        <div className="worry-free-guarantee-icon">
                          <img
                            className="worryFree-image"
                            src={worryFreeLogo}
                          ></img>
                        </div>
                        <div className="worry-free-guarantee-sub">
                          <b className="has-black-dark-text">
                            <p>Worry free guarantee</p>
                          </b>
                          <p>
                            <a
                              href="https://support.twistedroad.com/article/111-our-worry-free-rental-guarantee"
                              target="_blank"
                            >
                              <u>Learn more</u>
                            </a>
                          </p>
                        </div>
                      </div>
                      {bikeData.twenty_point_inspected && (
                        <div className="flexible-cancellation">
                          <div className="flexible-cancellation-icon">
                            <img
                              className="twentyPointInspected-image"
                              src={calendarLogo}
                            ></img>
                          </div>
                          <div className="flexible-cancellation-sub">
                            <b className="has-black-dark-text">
                              <p>20 Point Inspected</p>
                            </b>
                            <p>
                              <a
                                href="https://support.twistedroad.com/article/121-20-point-inspection"
                                target="_blank"
                              >
                                <u>Learn more</u>
                              </a>
                            </p>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                  {/* {!isMobile && bikeData.for_sale && (
                      <SellingCallOut
                        motorcycleUUID={bikeData.bike_uuid_id}
                        isPartner={bikeData.is_partner}
                        partnerType={bikeData.partner_type}
                        sellPriceCents={bikeData.sale_price_cents}
                        sellPriceCurrency={bikeData.sale_price_currency}
                        sellerAvatarCloudinaryID={
                          bikeData.bike_owner_avatar_cloudinary_public_id
                        }
                        sellerID={bikeData.bike_owner_id}
                        sellerName={bikeData.bike_owner_name}
                        ownerLink={bikeData.owner_link}
                        monthlyPriceCents={bikeData.sale_price_monthly_cents}
                        monthlyPriceCurrency={
                          bikeData.sale_price_monthly_currency
                        }
                      />
                    )} */}
                </Columns.Column>
              </Columns>
            </Container>
          </React.Fragment>
        )}
        <TryMeModal
          modalOpen={showTryMeModal}
          onClose={() => this.setState({ showTryMeModal: false })}
          isMobile={isMobile}
        />
      </>
    )
  }
}

export default BikeListing
